// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../queries/useDataEngine';

export const DocumentInventoryService = {
  getAllDocumentInventory: (params = {}, loader = false) =>
    axios.get(`${BASE_URL}/docinv`, {
      params,
      loader,
    }),

  advanceDocumentSearch: (body, loader = false) =>
    axios.post(`${BASE_URL}/documentsearch`, body, {
      loader,
    }),

  documentSftpSync: (body) =>
    axios.post(`${BASE_URL}/document_sftp_sync`, body),

  rollbackDocument: (body) => axios.post(`${BASE_URL}/rollback-document`, body),

  downloadDocument: ({ params, config = {} }) =>
    axios.get(`${BASE_URL}/export-document`, {
      params,
      responseType: 'arraybuffer',
      ...config,
    }),

  getDocumentMarkdown: (params, config = {}) =>
    axios.get(`${BASE_URL}/file-content`, {
      params,
      ...config,
    }),

  getVersionDetails: (params) =>
    axios.get(`${BASE_URL}/doc-version`, {
      params,
    }),

  saveAsNewVersion: (body) => axios.post(`${BASE_URL}/doc-version`, body),

  deleteDocument: (params) =>
    axios.delete(`${BASE_URL}/update-document`, {
      params,
    }),

  updateDocument: (body) => axios.put(`${BASE_URL}/create-document`, body),

  getTags: () => axios.get(`${BASE_URL}/documentTags`),

  getDocumentLinkedEntities: (params) =>
    axios.get(`${BASE_URL}/document-linked-entities`, {
      params,
    }),

  updateDocumentLinkedEntities: (body) =>
    axios.post(`${BASE_URL}/update-document-link`, body),
};
